import { apiClient } from './client';
import {AxiosResponse} from 'axios';
import {Page} from "@/models/Page";
import {array} from "yup";

const baseUrl = "region"

export const searchByNameForCountries = (query: string,countryIds:Array<number>) => {
    return new Promise((resolve) => {

        apiClient.get(`${baseUrl}/search/findByCountry?ids=${countryIds.join(',')}`)
            .then((res) => {

                if(!res.data._embedded || res.data._embedded.regions.length <=0 ){
                    return resolve([]);
                }

                if(!query || query.length == 0){
                    return resolve(res.data);
                }

                return resolve(res.data._embedded.regions.filter((c)=> c.name.toLowerCase().includes(query.toLowerCase())));

            })
            .catch(() => {
                resolve([])
            })

    })
}
export const searchByIds = (ids: string[]) => {

    if(ids == null || ids.length < 0) {
        return new Promise((resolve) => {resolve([])})
    }

    if(typeof ids  !== "string"){
        ids = ids.join(',')
    }

    return apiClient.get(`${baseUrl}/search/findByIds?ids=${ids}`)
}
